import { render, staticRenderFns } from "./Bracket.vue?vue&type=template&id=4bf5f9ec&scoped=true&"
import script from "./Bracket.vue?vue&type=script&lang=js&"
export * from "./Bracket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5f9ec",
  null
  
)

export default component.exports